import styled from 'styled-components';

/*
 * Styled anchor that opens a link in new window
 */
export const StyledAnchor = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  color: ${({
    theme: {
      colors: {
        text: { link_hover },
      },
    },
  }) => link_hover};

  &:hover {
    color: ${({
      theme: {
        colors: {
          text: { link_hover },
        },
      },
    }) => link_hover};
  }
`;

/*
 * Styled anchor for internal links that opens link in same view
 */
export const StyledAnchorInternal = styled.a`
  color: ${({
    theme: {
      colors: {
        text: { link },
      },
    },
  }) => link};

  &:hover {
    color: ${({
      theme: {
        colors: {
          text: { link_hover },
        },
      },
    }) => link_hover};
  }
`;
